import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const sewageTrashQuestions = [
  {
    id: 1,
    question: "What is the capital of France?",
    options: {
      optionA: "Berlin",
      optionB: "Paris",
      optionC: "Rome",
      optionD: "Madrid",
    },
    correctOptionValue: "Paris",
  },
  {
    id: 2,
    question: "Which planet is known as the Red Planet?",
    options: {
      optionA: "Earth",
      optionB: "Mars",
      optionC: "Jupiter",
      optionD: "Saturn",
    },
    correctOptionValue: "Mars",
  },
  {
    id: 3,
    question: "Who wrote 'To Kill a Mockingbird'?",
    options: {
      optionA: "Harper Lee",
      optionB: "Mark Twain",
      optionC: "George Orwell",
      optionD: "J.K. Rowling",
    },
    correctOptionValue: "Harper Lee",
  },
  {
    id: 4,
    question: "What is the chemical symbol for water?",
    options: {
      optionA: "O2",
      optionB: "H2",
      optionC: "H2O",
      optionD: "CO2",
    },
    correctOptionValue: "H2O",
  },
  {
    id: 5,
    question: "In which year did the Titanic sink?",
    options: {
      optionA: "1905",
      optionB: "1912",
      optionC: "1918",
      optionD: "1925",
    },
    correctOptionValue: "1912",
  },
];

export interface IScreen2Options {
  optionA: string | null;
  optionB: string | null;
  optionC: string | null;
  optionD: string | null;
}

export interface IScreen2Questions {
  id: number;
  question: string;
  options: IScreen2Options;
  correctOptionValue: string;
}

interface IRoot {
  currentQuestion: IScreen2Questions | null;
  remainingQuestions: IScreen2Questions[];
  correctAnswers: number;
}

const initialState: IRoot = {
  currentQuestion: sewageTrashQuestions[0],
  remainingQuestions: sewageTrashQuestions.slice(1),
  correctAnswers: 0,
};

const slice = createSlice({
  name: "sewageTrash",
  initialState,
  reducers: {
    initialQuizDat(state) {
      state.currentQuestion = sewageTrashQuestions[0];
      state.remainingQuestions = sewageTrashQuestions.splice(1);
    },
    currentQuestion(state, action: PayloadAction<IScreen2Questions | null>) {
      state.currentQuestion = action.payload;
    },
    remainingQuestions(state, action: PayloadAction<IScreen2Questions[]>) {
      state.remainingQuestions = action.payload;
    },
    correctAnswers(state) {
      state.correctAnswers = state.correctAnswers + 1;
    },
    resetAll(state) {
      state.currentQuestion = initialState.currentQuestion;
      state.remainingQuestions = initialState.remainingQuestions;
      state.correctAnswers = 0;
    },
  },
});

export const SewageTrashActions = slice.actions;

export const reducer = slice.reducer;

export default slice;
